import SurveyCompleted from './SurveyCompleted';
export default SurveyCompleted;
